import { useEffect, useState } from "react";
import { MDFeEventoOutput } from "./MDFe.Evento.Dto";
import { showToast } from "src/componentes";
import {
  MDFeEventoEnviar,
  MDFeEventoFiltrar,
  MDFeFiltrar,
} from "src/services/Fiscal.Service";
import { useSearchParams } from "react-router-dom";
import { MapearErrosServidor } from "src/hook/Functions";
import { ETipoEventoMDFe } from "../MDFe.Dto";

const MDFeEventoCode = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<MDFeEventoOutput[]>([]);
  const [searchParams] = useSearchParams();
  const [modalShowPropriedades, setModalShowPropriedades] = useState(false);

  const action = searchParams.get("action");
  const tipoEventoParam = searchParams.get("tipoEvento");
  const chaveParam = searchParams.get("chave");

  const [mdfeId, setMdfeId] = useState<number>(
    Number(searchParams.get("mdfeId") ?? searchParams.get("id") ?? 0)
  );

  const isEncerrarDirect = action === "encerrar" || tipoEventoParam === "110112";

  const [modalShowCadastro, setModalShowCadastro] = useState(isEncerrarDirect);
  const [evento, setEvento] = useState<MDFeEventoOutput>();

  const tipoEventoInicial = isEncerrarDirect
    ? ETipoEventoMDFe.Encerramento
    : ETipoEventoMDFe.Cancelamento;

  const onShowModalCadastro = (show: boolean) => setModalShowCadastro(show);
  const onReturnModalPropriedades = () => setModalShowPropriedades(false);

  const filtrar = async (id: number) => {
    if (!id || id <= 0) return;
    setLoading(true);
    try {
      const response = await MDFeEventoFiltrar(id);
      if (response.data.success) {
        setData(response.data.data || []);
      } else {
        MapearErrosServidor(response.data.notifications, showToast);
      }
    } catch (error) {
      console.error("Erro ao buscar eventos do MDF-e:", error);
      showToast({
        message: "Ocorreu erro ao buscar dados dos eventos",
        title: "Erro",
        variant: "Danger",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const urlMdfeId = Number(
      searchParams.get("mdfeId") ?? searchParams.get("id") ?? 0
    );
    if (urlMdfeId > 0 && urlMdfeId !== mdfeId) {
      setMdfeId(urlMdfeId);
    }
    if (isEncerrarDirect) {
      setModalShowCadastro(true);
    }
  }, [searchParams, isEncerrarDirect]);

  useEffect(() => {
    if (mdfeId <= 0 && chaveParam && chaveParam.length === 44) {
      const serie = Number(chaveParam.substring(22, 25));
      const numeroMDFe = Number(chaveParam.substring(25, 34));
      if (numeroMDFe > 0) {
        MDFeFiltrar({ serie, numeroMDFe } as any)
          .then((resp) => {
            if (resp.data.success && resp.data.data?.length > 0) {
              const item = resp.data.data[0];
              setMdfeId(item.id);
            }
          })
          .catch(() => {});
      }
    }
  }, [mdfeId, chaveParam]);

  useEffect(() => {
    if (mdfeId > 0) {
      filtrar(mdfeId);
    }
  }, [mdfeId]);

  const handleClickPropriedades = (value: MDFeEventoOutput) => () => {
    setModalShowPropriedades(true);
    setEvento(value);
  };

  const onSendModalPropriedades = async (value: MDFeEventoOutput) => {
    onReturnModalPropriedades();
    setLoading(true);
    try {
      const response = await MDFeEventoEnviar(value.id);
      if (response.data.success === true) {
        await filtrar(mdfeId);
        showToast({
          message: "Evento enviado com sucesso",
          title: "Sucesso",
          variant: "Success",
        });
      } else {
        MapearErrosServidor(response.data.notifications, showToast);
      }
    } catch (error) {
      console.error("Erro ao enviar evento:", error);
      showToast({
        message: "Ocorreu erro ao enviar evento",
        title: "Erro",
        variant: "Danger",
      });
    } finally {
      setLoading(false);
    }
  };

  const onDeleteModalPropriedades = async (value: MDFeEventoOutput) => {
    // Endpoints do backend não preveem delete direto de evento de MDF-e, mas mantém o feedback
    showToast({
      message: "Operação não permitida para eventos transmitidos",
      title: "Aviso",
      variant: "Warning",
    });
  };

  const onReloadModalPropriedades = () => {
    if (mdfeId > 0) {
      filtrar(mdfeId);
    }
  };

  return {
    loading,
    data,
    mdfeId,
    modalShowPropriedades,
    modalShowCadastro,
    evento,
    tipoEventoInicial,
    onShowModalCadastro,
    onReturnModalPropriedades,
    handleClickPropriedades,
    onSendModalPropriedades,
    onDeleteModalPropriedades,
    onReloadModalPropriedades,
  };
};

export default MDFeEventoCode;
